// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-close {
  width: 1em;
  height: 1em;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  position: absolute;
  top: 10px;
  right: 10px;
}

.btn-close::before {
  content: "×";
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-header {
  position: relative;
}

.kiosk-wrapper .form-group {
  margin-bottom: 5px;
}

.kiosk-wrapper .form-centered {
  max-width: 500px;
  margin: 0 auto;
}

#kiosk-signin-container .rsvp-form label.block,
#kiosk-signin-container .rsvp-form legend,
#kiosk-signin-container .rsvp-form .poll-header,
#kiosk-signin-container .rsvp-form fieldset legend,
#kiosk-signin-container .rsvp-form .checkbox label,
#kiosk-signin-container .rsvp-form .i-checks label {
  text-align: left;
}

#kiosk-signin-container .rsvp-form .meeting-registration-block {
  padding-left: 0;
  margin-left: 0;
}

#kiosk-signin-container .rsvp-form .meeting-attendance-option,
#kiosk-signin-container .rsvp-form .meeting-registration-block .col-xs-12 {
  padding-left: 0;
}

#kiosk-signin-container .rsvp-form .speaker-registration-buttons,
#kiosk-signin-container .rsvp-form .attendance-options,
#kiosk-signin-container .rsvp-form .translation-options,
#kiosk-signin-container .rsvp-form .accessibility-needs-buttons {
  margin-left: 0;
  padding-left: 0;
}

#kiosk-signin-container .rsvp-form .meeting-registration-block fieldset legend {
  text-align: left;
}

/* ============================================================
   Kiosk-mode touch targets (Material 48 px baseline)
   ------------------------------------------------------------
   Hardware kiosks are touch-first and often used in lobby
   settings by older users or users wearing gloves. The
   participant-facing form inputs are bumped to a 48 × 48 px
   minimum hit area (Material Design touch-target guideline)
   with a larger font for at-arms-length legibility. Scoped to
   .kiosk-wrapper so non-kiosk uses of the same form partials
   (regular event registration, embeds) remain unaffected.

   Admin UI is NOT inside .kiosk-wrapper and is unchanged.
   ============================================================ */

.kiosk-wrapper input[type="text"],
.kiosk-wrapper input[type="email"],
.kiosk-wrapper input[type="tel"],
.kiosk-wrapper input[type="number"],
.kiosk-wrapper input[type="password"],
.kiosk-wrapper input[type="search"],
.kiosk-wrapper input[type="url"],
.kiosk-wrapper select,
.kiosk-wrapper textarea {
  min-height: 48px;
  padding: 10px 14px;
  font-size: 1.125rem; /* ~18px at default base */
  line-height: 1.4;
}

.kiosk-wrapper textarea {
  min-height: 96px;
}

/* Native checkbox + radio inputs. We size the visible control to 24 px
   and rely on label padding (below) for the remaining hit area, so the
   tappable region is at least 48 × 48 px. */
.kiosk-wrapper input[type="checkbox"],
.kiosk-wrapper input[type="radio"] {
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  vertical-align: middle;
  cursor: pointer;
}

/* Label wrappers around checkboxes / radios — Bootstrap .checkbox and
   .radio plus Metronic .i-checks. Making the label itself 48 px tall
   gives the entire row a tappable footprint that matches the touch
   target guideline, even when the visible control is smaller. */
.kiosk-wrapper .checkbox,
.kiosk-wrapper .radio,
.kiosk-wrapper .i-checks,
.kiosk-wrapper .checkbox label,
.kiosk-wrapper .radio label,
.kiosk-wrapper .i-checks label {
  min-height: 48px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1.0625rem; /* ~17px */
  line-height: 1.4;
  cursor: pointer;
}

/* Metronic iCheck plugin (if initialized) replaces native inputs with
   sprite-backed divs. Scale them up by 1.5 so the rendered control
   matches the larger native sizing. transform-origin keeps them aligned
   with the label text; margin-right prevents overlap with the label. */
.kiosk-wrapper [class^="icheckbox_"],
.kiosk-wrapper [class*=" icheckbox_"],
.kiosk-wrapper [class^="iradio_"],
.kiosk-wrapper [class*=" iradio_"] {
  transform: scale(1.5);
  transform-origin: left center;
  margin-right: 18px;
  margin-left: 6px;
}

.kiosk-wrapper button,
.kiosk-wrapper input[type="submit"],
.kiosk-wrapper input[type="button"],
.kiosk-wrapper .btn,
.kiosk-wrapper a.btn {
  min-height: 48px;
  padding: 12px 20px;
  font-size: 1.0625rem;
  line-height: 1.4;
}

.kiosk-wrapper label:not(.checkbox):not(.radio):not(.i-checks) {
  font-size: 1rem;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./Scripts/Modules/Kiosk/kiosk-check-in.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;iEAYiE;;AAEjE;;;;;;;;;EASE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAE,0BAA0B;EAC/C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;4CAE4C;AAC5C;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;gEAGgE;AAChE;;;;;;EAME,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB,EAAE,UAAU;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;uEAGuE;AACvE;;;;EAIE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".btn-close {\r\n  width: 1em;\r\n  height: 1em;\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n}\r\n\r\n.btn-close::before {\r\n  content: \"×\";\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  color: #000;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.modal-header {\r\n  position: relative;\r\n}\r\n\r\n.kiosk-wrapper .form-group {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.kiosk-wrapper .form-centered {\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n}\r\n\r\n#kiosk-signin-container .rsvp-form label.block,\r\n#kiosk-signin-container .rsvp-form legend,\r\n#kiosk-signin-container .rsvp-form .poll-header,\r\n#kiosk-signin-container .rsvp-form fieldset legend,\r\n#kiosk-signin-container .rsvp-form .checkbox label,\r\n#kiosk-signin-container .rsvp-form .i-checks label {\r\n  text-align: left;\r\n}\r\n\r\n#kiosk-signin-container .rsvp-form .meeting-registration-block {\r\n  padding-left: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n#kiosk-signin-container .rsvp-form .meeting-attendance-option,\r\n#kiosk-signin-container .rsvp-form .meeting-registration-block .col-xs-12 {\r\n  padding-left: 0;\r\n}\r\n\r\n#kiosk-signin-container .rsvp-form .speaker-registration-buttons,\r\n#kiosk-signin-container .rsvp-form .attendance-options,\r\n#kiosk-signin-container .rsvp-form .translation-options,\r\n#kiosk-signin-container .rsvp-form .accessibility-needs-buttons {\r\n  margin-left: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n#kiosk-signin-container .rsvp-form .meeting-registration-block fieldset legend {\r\n  text-align: left;\r\n}\r\n\r\n/* ============================================================\r\n   Kiosk-mode touch targets (Material 48 px baseline)\r\n   ------------------------------------------------------------\r\n   Hardware kiosks are touch-first and often used in lobby\r\n   settings by older users or users wearing gloves. The\r\n   participant-facing form inputs are bumped to a 48 × 48 px\r\n   minimum hit area (Material Design touch-target guideline)\r\n   with a larger font for at-arms-length legibility. Scoped to\r\n   .kiosk-wrapper so non-kiosk uses of the same form partials\r\n   (regular event registration, embeds) remain unaffected.\r\n\r\n   Admin UI is NOT inside .kiosk-wrapper and is unchanged.\r\n   ============================================================ */\r\n\r\n.kiosk-wrapper input[type=\"text\"],\r\n.kiosk-wrapper input[type=\"email\"],\r\n.kiosk-wrapper input[type=\"tel\"],\r\n.kiosk-wrapper input[type=\"number\"],\r\n.kiosk-wrapper input[type=\"password\"],\r\n.kiosk-wrapper input[type=\"search\"],\r\n.kiosk-wrapper input[type=\"url\"],\r\n.kiosk-wrapper select,\r\n.kiosk-wrapper textarea {\r\n  min-height: 48px;\r\n  padding: 10px 14px;\r\n  font-size: 1.125rem; /* ~18px at default base */\r\n  line-height: 1.4;\r\n}\r\n\r\n.kiosk-wrapper textarea {\r\n  min-height: 96px;\r\n}\r\n\r\n/* Native checkbox + radio inputs. We size the visible control to 24 px\r\n   and rely on label padding (below) for the remaining hit area, so the\r\n   tappable region is at least 48 × 48 px. */\r\n.kiosk-wrapper input[type=\"checkbox\"],\r\n.kiosk-wrapper input[type=\"radio\"] {\r\n  width: 24px;\r\n  height: 24px;\r\n  margin: 0 8px 0 0;\r\n  vertical-align: middle;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Label wrappers around checkboxes / radios — Bootstrap .checkbox and\r\n   .radio plus Metronic .i-checks. Making the label itself 48 px tall\r\n   gives the entire row a tappable footprint that matches the touch\r\n   target guideline, even when the visible control is smaller. */\r\n.kiosk-wrapper .checkbox,\r\n.kiosk-wrapper .radio,\r\n.kiosk-wrapper .i-checks,\r\n.kiosk-wrapper .checkbox label,\r\n.kiosk-wrapper .radio label,\r\n.kiosk-wrapper .i-checks label {\r\n  min-height: 48px;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  font-size: 1.0625rem; /* ~17px */\r\n  line-height: 1.4;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Metronic iCheck plugin (if initialized) replaces native inputs with\r\n   sprite-backed divs. Scale them up by 1.5 so the rendered control\r\n   matches the larger native sizing. transform-origin keeps them aligned\r\n   with the label text; margin-right prevents overlap with the label. */\r\n.kiosk-wrapper [class^=\"icheckbox_\"],\r\n.kiosk-wrapper [class*=\" icheckbox_\"],\r\n.kiosk-wrapper [class^=\"iradio_\"],\r\n.kiosk-wrapper [class*=\" iradio_\"] {\r\n  transform: scale(1.5);\r\n  transform-origin: left center;\r\n  margin-right: 18px;\r\n  margin-left: 6px;\r\n}\r\n\r\n.kiosk-wrapper button,\r\n.kiosk-wrapper input[type=\"submit\"],\r\n.kiosk-wrapper input[type=\"button\"],\r\n.kiosk-wrapper .btn,\r\n.kiosk-wrapper a.btn {\r\n  min-height: 48px;\r\n  padding: 12px 20px;\r\n  font-size: 1.0625rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.kiosk-wrapper label:not(.checkbox):not(.radio):not(.i-checks) {\r\n  font-size: 1rem;\r\n  line-height: 1.4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
